<mat-toolbar class="toolbar">
  <ng-content select="cmp-toolbar-button"></ng-content>
</mat-toolbar>